import { InventoryReportFormData, InventoryReportRow } from './types';

export const reportStatusOptions = [
  { id: 'all', name: 'Tất cả' },
  { id: 'draft', name: 'Nháp' },
  { id: 'posted', name: 'Đã ghi sổ' },
  { id: 'approved', name: 'Đã duyệt' },
  { id: 'inactive', name: 'Ngưng dùng' },
];

export const reportTypeOptions = [
  { id: 'monthly_receipts', name: 'Nhập theo tháng' },
  { id: 'material_ratio', name: 'Tỷ lệ vật tư / doanh số' },
];

export const inventoryReportRows: InventoryReportRow[] = [];

export const createDefaultReportForm = (companyId: string): InventoryReportFormData => ({
  report_type: 'monthly_receipts',
  code: '',
  name: '',
  reference: '',
  qty: '',
  amount: '',
  status: 'draft',
  company_id: companyId,
  note: '',
});
